import HamburgerIcon from './HamburgerIcon';

export default HamburgerIcon;
